<template>
    <div class="field" v-if="label && clientPods">
      <div v-if="!loadedClipods || (clientPods && clientPods.length > 0)">
        <label class="label">{{label.pod}} <Info multilined :tooltipText="label.podTooltip"/></label>
            <div class="control" @mouseleave="timeframeActive = false">
              <div class="dropdown" :class="{'is-active': podDropActive, 'full-width': fullwidth}">
                <div class="dropdown-trigger" :class="{'full-width': fullwidth}">
                  <button
                    class="button"
                    :class="{'full-width': fullwidth}"
                    @click="podDropActive = !podDropActive"
                    @blur="showMultiplePodSelection ? '' : podDropActive = false">
                    <span>
                      <template v-if="activeClipod && activeClipod.isDelegatedAccess && !showMultiplePodSelection"><strong>A.D.</strong> - </template>
                      {{selectText}}
                    </span>
                    <span class="icon is-small"><awesome-icon icon="angle-down" aria-hidden="true"/></span>
                  </button>
                </div>
                <div v-if="showMultiplePodSelection" class="dropdown-menu" role="menu">
                  <div class="dropdown-content">
                    <div v-for="clipod of clipods" v-bind:key="clipod.pod.id">
                      <div class="dropdown-item">
                        <div class="item-pod">
                          <input
                            v-model="multiplePodSelection[clipod.pod.id].selected"
                            @change="onMPSelectionChange"
                            :value="clipod.pod.id"
                            :id="clipod.pod.id"
                            type="checkbox">
                          <label :for="clipod.pod.id">
                            <template v-if="clipod.isDelegatedAccess"><strong>A.D.</strong> - </template>
                            {{clipod.podCustomName}}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="dropdown-menu" role="menu">
                  <div class="dropdown-content">
                    <a
                      class="dropdown-item"
                      v-for="clipod of clipods"
                      v-bind:value="clipod.pod.id"
                      v-bind:key="clipod.pod.id"
                      @mousedown="selectPod(clipod.pod)"
                    >
                      <template v-if="clipod.isDelegatedAccess"><strong>A.D.</strong> - </template>
                      {{formatClipodForSelection(clipod)}}
                    </a>
                  </div>
                </div>
              </div>
            </div>
      </div>
        <div v-else class="notification is-warning">
          Vous n'avez aucun point d'accès lié à votre compte. Pour accéder aux données de votre compteur intelligent, veuillez encoder une demande d'accès depuis la page 
          <a @mousedown="$router.push('/profile/pods', () => {})">
            <strong>"Mon profil -> Mes points d'accès"</strong>
          </a>.
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { PODService } from '../services'
import Info from '../components/Info.vue'
import { sortRegisters } from '../helpers'

export default {
    components: {
        Info
    },
    data() {
        return {
            selectedPodId: null,
            clipods: null,
            podDropActive: false,
            // value used if multiple pod selection
            multiplePodSelection: {},
            loadedClipods: false
        }
    },
    props: ['userId', 'showMultiplePodSelection', 'fullwidth'],
    computed: {
        ...mapState({ label: state => state.labels.alerts }),
        selectText() {
          if (this.showMultiplePodSelection) {
            return 'Sélection de POD'
          } else {
            return this.selectedPodId ? `${this.activeClipod.podCustomName} - ${this.activePod.EAN}` : null
          }
        },
        clientPods() {
            let clientPods = new Array();
            if(!this.clipods)
                return clientPods;
            this.clipods.forEach(clipod => {
                if(!clientPods.some(pod => pod.id === clipod.pod.id)) {
                    clientPods.push(clipod.pod);
                }
            })
            return clientPods;
        },
        // clientPodIDs() {
        //   return this.clientPods.map(pod => pod.id)
        // },
        activePod() {
            return this.clientPods.find(pod => pod.id === this.selectedPodId);
        },
        activeClipod() {
            if(!this.selectedPodId)
              return null
            return this.clipods ? this.clipods.find(clipod => clipod.pod.id === this.selectedPodId) : null
        },
        allRegistersIDs() {
            let allRegistersIDs = [];
            if (!this.clipods) return allRegistersIDs;
            this.clipods.forEach(clipod => {
                clipod.pod.variable.forEach(variable => {
                    if(!allRegistersIDs.some(registerID => registerID == variable.id)) {
                        allRegistersIDs.push(variable.id);
                    }
                });
            });
            return allRegistersIDs;
        }
    },
    methods: {
        onPodSelected() {
            this.$emit('selectedPod', this.activeClipod);
        },
        selectPod(pod, load = true) {
          sessionStorage.setItem("user-pod", pod.id)
          this.selectedPodId = pod.id;
          pod.location && !this.activeClipod.isDelegatedAccess ? sessionStorage.setItem("user-location", pod.location.id) : sessionStorage.setItem("user-location", "")
          load && this.onPodSelected()
        },
        // for multi pods selection
        onMPSelectionChange() {
          this.$emit('multiplePodSelectionChanged', this.multiplePodSelection)
        },
        formatClipodForSelection(clipod) {
            let desc = clipod.podCustomName;
            if(clipod.pod.EAN && clipod.pod.EAN.length > 0)
             desc += " - " + clipod.pod.EAN;
            return desc;
        },
        initMultiplePodSelection() {
          if (!this.clipods) return;
          for(let clipod of this.clipods) {
            const variableIDs = clipod.pod.variable ? clipod.pod.variable.map(v => v.id) : []
            this.multiplePodSelection[clipod.pod.id] = {
              selected: variableIDs.length > 0,
              pod: clipod.pod,
              registersIDs: variableIDs
            }
          }
          this.$emit('multiplePodSelectionChanged', this.multiplePodSelection)
        }
    },
    created() {
        const defaultPodId = sessionStorage.getItem("user-pod")
        PODService.getActivePods(this.userId, true).then(clipods => {
            if (!clipods) return;
            for(let clipod of clipods) {
              if(clipod.pod && clipod.pod.variable) {
                clipod.pod.variable = sortRegisters(clipod.pod.variable)
              }
            }
            this.clipods = clipods
            // set a default selected pod
            if (defaultPodId && this.clientPods.some(pods => pods.id == defaultPodId)) {
              this.selectedPodId = defaultPodId;
            }
            else {this.selectedPodId = this.clientPods.length > 0 ? this.clientPods[0].id : null;}
            this.onPodSelected()
            this.$emit('allRegistersIDs', this.allRegistersIDs)
            this.$emit('allClipods', this.clipods)
            this.initMultiplePodSelection()
        })
        .finally(() => {
          this.loadedClipods = true
        })
    }
}
</script>

<style lang="scss" scoped>
.client-pods{
  display: flex;
  align-items: center;

  & > label {
    margin-right: 10px;
  }
}

@media screen and (min-width: 769px), screen and (max-width: 478px) {
  .full-width {
    width: 100%;

    &.button {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>